<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()">
    <v-card>
    
      <v-card-text class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <!-- <div class="text-center py-10">
          <h3>title</h3>
        </div> -->
        
        <p class="py-10 ma-0" style="text-align: center;" v-if="authLevel==0">
          <v-btn class="link-button" small color="primary" dark @click="resetServiceDate">
            {{ "lng_service_done_btn" | translate }}</v-btn></p>

        <p v-if="showRequestStatus" class="ma-0" style="text-align: center; color:red;">
          {{ "lng_service_done_btn" | translate }}
        </p>  
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalService from "../../services/global-service"
export default {
  name: "AlterServiceDate",
  data() {
    return {
      adminToken: undefined,
      dialog: false,
      authLevel:undefined,
      showRequestStatus: false
    }
  },
  props:{
    openDialog: {
      type: Boolean,
      default: false
    },
    systemData: {
      type: Object,
      default: () => {}
    },
    closeDialog: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      this.showRequestStatus = false;
    }
  },
  mounted() {
    this.authLevel = sessionStorage.authLevel;
    let token = sessionStorage.getItem("userToken");
    this.adminToken = token;
  },
  methods:{
    async resetServiceDate(){
      let data = await GlobalService.resetServiceDate(this.adminToken, this.systemData.id);
      if(data.status === 0){
        this.showRequestStatus = true;
      }
      this.$emit("refreshSystemsData");
    }
  }
}
</script>